import { ServerEvent } from './store';
import { PeaksPoint, PeaksPeriod } from './interfacesPeaks/PeaksJS';

export function mapToServerEvent(event: PeaksPoint | PeaksPeriod, primaryAnalysisSetId: string, eventTypeId: string, waveform: string): ServerEvent {
    if (isPeaksPoint(event)) {
        return {
            AnalysisSetId: primaryAnalysisSetId,
            EventTypeId: eventTypeId,
            RawStart: waveform === 'CWFT_RAW' ? event.timestamp : null,
            ProcessedStart: waveform === 'CWFT_PROCESSED' ? event.timestamp : null,
            SensorProcessedStart: waveform === 'CWFT_SENSOR_PROCESSED' ? event.timestamp : null,
        };
    } else {
        return {
            AnalysisSetId: primaryAnalysisSetId,
            EventTypeId: eventTypeId,
            RawStart: waveform === 'CWFT_RAW' ? event.startTime : null,
            RawEnd: waveform === 'CWFT_RAW' ? event.endTime : null,
            ProcessedStart: waveform === 'CWFT_PROCESSED' ? event.startTime : null,
            ProcessedEnd: waveform === 'CWFT_PROCESSED' ? event.endTime : null,
            SensorProcessedStart: waveform === 'CWFT_SENSOR_PROCESSED' ? event.startTime : null,
            SensorProcessedEnd: waveform === 'CWFT_SENSOR_PROCESSED' ? event.endTime : null,
        };
    }
}

export function isPeaksPoint(obj: any): obj is PeaksPoint {
    return obj.timestamp !== undefined;
}

export function isPeaksPeriod(obj: any): obj is PeaksPeriod {
    return obj.startTime !== undefined;
}
